import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from "./Form.js";
import ContentWithImages from "./ContentWithImages.js";
import DoctorBite from "../../DoctorBite.js";
import PatientReviews from "../../PatientReview.js";
import GetInTouch from "../../GetInTouch.js";
import FollowYt from "../../FollowYt.js";
import Counter from "../../../NumCounter.js";
import Breadcrumb from "../../Breadcrum.js";

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Hair Restoration in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
      <meta name="description" content="Get advanced hair restoration treatment in Delhi, India. Learn about procedures, recovery, and cost at expert hair transplant clinics." />
      <meta name="keywords" content="hair restoration Delhi, hair loss treatment, hair transplant Delhi, scalp treatment, hair regrowth clinic, alopecia treatment" />
      <link rel="canonical" href="https://entdelhi.com/hair-restoration/" />
      <meta property="og:title" content="Hair Restoration in Delhi, India | Treatment, Cost, Doctor, Clinic" />
      <meta property="og:description" content="Get advanced hair restoration treatment in Delhi, India. Learn about procedures, recovery, and cost at expert hair transplant clinics." />
      <meta name="robots" content="index, follow" />
      {/* You can add more meta tags as needed */}
    </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages />
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        <GetInTouch />
      </main>
    </div>
  );
}
